/**
 * Formatação de moeda em pt-BR.
 * - Sempre R$ + 2 casas decimais.
 * - showSign=true exibe '+ R$' ou '- R$' explicitamente (útil em listas mistas).
 * - Valores negativos sempre mostram o '-'.
 */
export function formatCurrency(value: number, opts?: { showSign?: boolean }): string {
  const num = Number(value) || 0;
  const abs = Math.abs(num).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  if (num < 0) return `- R$ ${abs}`;
  if (opts?.showSign) return `+ R$ ${abs}`;
  return `R$ ${abs}`;
}

/**
 * Formata percentual com 1 casa decimal (ex: 12.3%).
 */
export function formatPercent(value: number): string {
  const num = Number(value) || 0;
  return `${num.toFixed(1)}%`;
}

/**
 * Converte 'YYYY-MM-DD' (formato do banco) para 'dd/mm/yyyy' (display BR).
 */
export function formatDateBR(isoDate: string | null | undefined): string {
  if (!isoDate) return '—';
  const [y, m, d] = isoDate.substring(0, 10).split('-');
  if (!y || !m || !d) return isoDate;
  return `${d}/${m}/${y}`;
}
